import { createRoute } from 'atomic-router';
import { createDomain, createApi } from 'effector';

export const routesDomain = createDomain('routesDomain');

// Events

// Stores

export const $notFoundRouteOpened = routesDomain.createStore(false);

// Effects

// Apis

export const notFoundRouteApi = createApi($notFoundRouteOpened, {
  opened: () => true,
  closed: () => false,
});

// Routes
export const homeRoute = createRoute();
export const projectsRoute = createRoute();
export const enHomeRoute = createRoute();
export const enProjectsRoute = createRoute();
export const notFoundRoute = createRoute();
